import React from "react"
import trangleLogo from '../../assets/triangle.svg'
export class AudienceBreakdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openFields: new Set()
    }
  }

  // audienceBreakdown: {
  //   marketable: {
  //     total: marketableCustomers,
  //     prospects: sumProspects,
  //     customers: sumCustomers
  //   },
  //   control: {
  //     total: 0,
  //     prospects: 0,
  //     customers: 0
  //   }
  // },

  render() {
    if (this.props.audienceBreakdown !== null) {
      return (
        <React.Fragment>
          <div style={{ paddingTop: '2vh', paddingBottom: '1vh' }}>
            {Object.keys(this.props.audienceBreakdown).sort().reverse().map((field, idx) => {
              return (
                <React.Fragment key={field + idx}>
                  <div style={{ paddingLeft: '10vw', paddingRight: '10vw', paddingTop: '1vh' }}>
                    <div style={{ display: "flex", justifyContent: 'space-between', marginBottom: '3vh' }}>
                      <div style={{ display: 'flex', maxHeight: '10vh' }}>
                        <div onClick={() => {
                          this.setState(e => {
                            if (e.openFields.has(field)) {
                              e.openFields.delete(field)
                            }
                            else {
                              e.openFields.add(field)
                            }
                            return e
                          })
                        }} style={{ transform: this.state.openFields.has(field) ? "rotate(0.25turn)" : "rotate(0.5turn)" }}>
                          <img src={trangleLogo} style={{ height: '5vh' }} />
                        </div>
                        <h2 style={{ paddingTop: 5, paddingLeft: 10 }}>
                          {field.split('_').map(obj => {
                            return obj.charAt(0).toUpperCase() + obj.slice(1) + ' '
                          })}
                        </h2>
                      </div>
                      <span style={{ boxShadow: 'var(--box-shadow-stripe)', padding: '1%', fontSize: '16px', borderRadius: 5 }}>
                        Total: <b>{this.props.audienceBreakdown[field].total.toLocaleString()}</b>
                      </span>
                    </div>
                    {!this.state.openFields.has(field) && (
                      <div style={{ paddingTop: '1vh', paddingBottom: '1vh', paddingLeft: '10vw', paddingRight: '0' }}>
                        {Object.keys(this.props.audienceBreakdown[field]).sort().map((obj, idx) => {
                          if (obj !== "total") {
                            return (
                              <div key={idx + obj} style={{ display: "flex", justifyContent: 'space-between', marginBottom: '3vh' }}>
                                <h2>
                                  {obj.split('_').map(title => {
                                    return title.charAt(0).toUpperCase() + title.slice(1) + ' '
                                  })}
                                </h2>
                                <span style={{ boxShadow: 'var(--box-shadow-stripe)', padding: '1%', fontSize: '16px', borderRadius: 5 }}>
                                  <b>{this.props.audienceBreakdown[field][obj].toLocaleString()}</b>
                                </span>
                              </div>
                            )
                          }
                        })}
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )
            })}
          </div>
        </React.Fragment>
      )
    }
    else {
      return (<div></div>)
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/audienceBreakdown/audienceBreakdown.jsx